/**
 * Historial del proveedor: filas de ProveedorSaldoHistory como debe / haber.
 * Pedido (más deuda) = debe; pago = haber. Saldo = saldo después del movimiento.
 * Sin filtro de fecha (el endpoint no lo soporta).
 */
import type { ProveedorSaldoHistoryRow } from "@/lib/api";

export type MovimientoCuentaProveedor = {
  id: number;
  fecha: string;
  tipo: string;
  referencia: string;
  descripcion: string;
  debe: number;
  haber: number;
  saldo: number;
};

function num(value: number | string | null | undefined): number {
  const n = typeof value === "number" ? value : parseFloat(String(value ?? ""));
  return Number.isFinite(n) ? n : 0;
}

/** Más nuevo primero; el primer saldo coincide con el saldo actual del proveedor. */
export function movimientosCuentaProveedor(
  rows: ProveedorSaldoHistoryRow[],
): MovimientoCuentaProveedor[] {
  return [...rows]
    .sort((a, b) => {
      const byDate = String(b.createdAt || "").localeCompare(String(a.createdAt || ""));
      return byDate !== 0 ? byDate : b.id - a.id;
    })
    .map((row) => {
      const cambio = num(row.montoCambio);
      return {
        id: row.id,
        fecha: row.createdAt,
        tipo: row.tipoMovimiento,
        referencia: row.referenciaId || "",
        descripcion: row.descripcion || "",
        debe: cambio < 0 ? -cambio : 0,
        haber: cambio > 0 ? cambio : 0,
        saldo: num(row.saldoNuevo),
      };
    });
}

export function movimientoCuentaMatches(m: MovimientoCuentaProveedor, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    m.referencia.toLowerCase().includes(q) ||
    m.descripcion.toLowerCase().includes(q)
  );
}
